
import { get_token, get_user_details } from "@/router";
import Swal from "sweetalert2";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import ReportCommentModal from "@/components/ReportCommentModal/ReportCommentModal.vue";
import CreateFeed from '@/components/CreateFeed/CreateFeed.vue'


export default {
  components: {
    HomeNavBar,
    ReportCommentModal,
    CreateFeed
  },
  props: {
    active_profile: {
      type: Object,
      default: null
    },
    questions: {
      type: Array,
      default: () => []
    }
  },
  computed: {

    isBusinessProfile() {
      const active_profile = this.base_profiles.find(profile => profile.is_active);
      return active_profile?.profile_type?.name?.toLowerCase() === 'business';
    },
    currentUserBaseProfile() {
      return this.user_base_profiles.find(profile => profile.is_active) || null;
    },
    paginatedReports() {
      const end = this.currentPage * this.reportsPerPage;
      return this.reports.slice(0, end);
    },
    hasMoreReports() {
      return this.reports.length > this.currentPage * this.reportsPerPage;
    },
    filter_finance_question_ids() {
      return this.profile_questions
        .filter(q => q.tab_field === 'finance')
        .flatMap(q => q.form?.form_sections || [])
        .flatMap(s => s.section?.question_sections || [])
        .map(qs => qs.question.id);
    },
    filter_about_question_ids() {
      return this.profile_questions
        .filter(q => !q.tab_field || q.tab_field === null || q.tab_field === 'about')
        .flatMap(q => q.form?.form_sections || [])
        .flatMap(s => s.section?.question_sections || [])
        .map(qs => qs.question.id);
    },
    all_section() {
    // questions is an array of forms, each with form_sections (sections)
    return this.questions.flatMap(form =>
      (form.form?.form_sections || []).map(fs => ({
        ...fs,
        formId: form.form?.id,
        formName: form.form?.name,
        section: fs.section,
        sectionId: fs.section?.id
      }))
    );
  }
  },
 
  watch: {
    activeTab(newVal) {
       if (newVal === 'posts') {
        this.filterReports();

      }
    }
  },  
  
  mounted() {
    this.user_id = this.$route.query.user_id
    this.base_profile_id = this.$route.query.base;
    this.user_details = get_user_details();
    this.token_exists = get_token();
    this.get_rating();

    this.filter_membership_payment_history();
    this.fetch_type_of_organization();
    this.fetch_type_of_profile();
    this.fetchProfiles();
    if(this.base_profile_id){
      this.payload = {
        filter_values: {
          base_profile: this.base_profile_id
          
        }
      }
      this.fetchCompanyProfile()
    }else{
      
      this.payload = {
        filter_values: {
          base_profile__creater_id:this.user_details.user_id,
          base_profile__is_active:"True"
          
        }
      }
      this.fetchCompanyProfile()

    }

  },
  data() {
    return ({
       
      email: '',
      phone_number: '',
      fileType: '',
      isLocalFile: false,
      local_file_url:null,
      latitude: null,
      longitude: null,
      rating: 0,
      user_base_profiles: [],
      totalRatings: 0,
      user_details: {
        "user_role": '',
        "user_id":null,

      },
      activeTab: 'posts',
      token_exists: true,
      isLoading: false,
      profile: {},
      errors: {},
      showPreview: false,
      file_name: '',
      user_id: '',
      membership_payment_history: [],
      userHasPaid: false,
      membership_name: '',
      company_name: '',
      type_of_organization: '',
      description: '',
      tell_number: '',
      location: '',
      organizationTypes: [],
      selected_type_of_organization: '',
      type_of_profile: [],
      base_profiles: [],
      currentProfile: null,
      displayLetter: '',
      displayName: '',
      reports: [],
      isBusinessProfile: false,
      companyData: null,
      profile_questions: [],
      base_profile_id:null,
      payload:{},
      currentPage: 1,
      reportsPerPage: 10,
      expandedReports: [],
      report_data: {},
      comment_modal_visible: false,
      edit_documents: {},
      report_name: '',
      report_description: '',
      report_id: null,
      upload_media: null,
      audio_file: null,
      audio_file_name: '',
      team_members: [],
      last_name: '',
      first_name: '',
      member_role: '',
      pitchdecks: [],
      fileError: '',
      fileName: '',
      edit_member_id: null,
      edit_pitchdeck_id:null,
      pitch_description:'',
      temporaryPost: null, 
      has_finance_access: false,
    finance_pccess_pending: false,
    finance_access_checked: false,

    });
  },
  methods: {

    filter_membership_payment_history() {
      this.token_exists = get_token();

      if (!this.user_id) {

        this.user_id = this.companyData?.base_profile?.creater;
      }

      const payload = {
        filter_values: {
          user_id: this.user_id,

        }
      }

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_membership_payment_history/`,
        method: "POST",
        data: JSON.stringify(payload),
        headers: this.token_exists
          ? {
            Authorization: `Token ${this.getToken()}`,
            "Content-Type": "application/json",
          }
          : {"Content-Type": "application/json" },
        success: (response) => {
          this.membership_payment_history = response.data.payment_history;

          this.userHasPaid = this.membership_payment_history.some(
            (payment) => payment.payment_status?.status === "paid"
          );
          this.membership_name =this.membership_payment_history[0]?.membership?.name || '';

        },
        complete: () => {
          this.isLoading = false;
        },
      })
    },
    editAnswer(question) {
        // Enable editing mode for the selected question
        question.isEditing = true;
      },
    toggleSection() {
      this.isOpen = !this.isOpen;
      const sectionBody = this.$refs.sectionBody;
      if (this.isOpen) {
        $(sectionBody).slideDown(200);
      } else {
        $(sectionBody).slideUp(200);
      }
    },
    getOptionValue(answerId, options) {

      if (!options || !Array.isArray(options)) {
        return null; // Return null if options is not an array
      }

      const normalizedAnswerIds = Array.isArray(answerId)
        ? answerId.map(id => (typeof id === 'string' ? parseInt(id, 10) : id))
        : [typeof answerId === 'string' ? parseInt(answerId, 10) : answerId];

      // Filter options to find all matches
      const matchedOptions = options.filter(opt => normalizedAnswerIds.includes(opt.id));

      // If answerId is an array (checkboxes), return all matched options' values
      if (Array.isArray(answerId)) {
        return matchedOptions.map(opt => opt.option);
      }
      return matchedOptions.length > 0 ? matchedOptions[0].option : null;
    },
    toggleCheckbox(qa, optionId, isChecked) {
      if (!qa.newAnswer) {
        // Initialize newAnswer with the current answer if it exists
        qa.newAnswer = Array.isArray(qa.answer) ? qa.answer.slice() : qa.answer ? qa.answer.split(',').map(opt => opt.trim()) : [];
      }

      if (isChecked) {
        // Add the option if it's not already in the array
        if (!qa.newAnswer.includes(optionId)) {
          qa.newAnswer.push(optionId);
        }
      } else {
        // Remove the option if it exists in the array
        const index = qa.newAnswer.indexOf(optionId);
        if (index > -1) {
          qa.newAnswer.splice(index, 1);
        }
      }
    },
    submitAnswer(qa) {

      const baseProfileId = this.companyData?.base_profile?.id;

      // Combine the newAnswer array with the existing answer if needed
      const combinedAnswers = qa.newAnswer || qa.answer;
      const filteredAnswers = Array.isArray(combinedAnswers)
        ? combinedAnswers.filter((value, index, self) => value && self.indexOf(value) === index) // Remove duplicates and empty values
        : combinedAnswers;

      const answer = Array.isArray(filteredAnswers)
        ? filteredAnswers.join(",") // Join array values into a comma-separated string
        : filteredAnswers;

      // Prepare the payload
      const payload = {
        base_profile_id: baseProfileId,
        answers: [
          {
            question_id: qa.question.id,
            answer: answer,
          },
        ],
      };

      // Send the AJAX request
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/answer_questions_for_base_profile/`,
        type: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify(payload),
        success: (response) => {
          if (response.status === "success") {
            const ansObj = this.companyData.answers.find(ans => ans.question.id === qa.question.id);
              if (ansObj) {
                ansObj.answer = answer;
              } else {
                this.companyData.answers.push({
                  question: qa.question,
                  answer: answer,
                });
              }
            qa.isEditing = false;
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.message || "An error occurred.",
            });
          }
        },
      });
    },
    getToken() {
      return get_token();
    },
    toggleSidebar() {
      this.$refs.sidebar.$el.classList.toggle('close');
    },

    get_rating() {
      if (!this.user_id) {

        this.user_id = this.user_details.user_id;
      }
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/retrieve_profile_rating/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        data: {
          user_id: this.user_id
        },
        success: (response) => {
          if (response.status === 'success') {
            this.rating = response.data.average_rating;
            this.totalRatings= response.data.total_count

          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    update_answer(questionId, value) {
      const questionSection = this.profile_questions
        ?.flatMap(f => f?.form?.form_sections || [])
        ?.flatMap(s => s?.section?.question_sections || [])
        ?.find(qs => qs?.question?.id === questionId);
    
      if (questionSection) {
        questionSection.answer = value;
      }
    },

    saveRating(ratingValue) {
      this.rating = ratingValue;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/create_profile_rating/`,
        type: "POST",
        headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ user_id: this.user_id, rating: this.rating }),
        success: (response) => {
          if (response.status === "success") {
            this.rating = response.data.average_rating;
            this.totalRatings= response.data.total_count
          }
        },
      });
    },

    handleFileUpload(event) {
      const files = event.target.files;
      if (files && files.length > 0) {
        const file = files[0];
        if (this.validateFile(file)) {
          this.cv = file;
          this.file_name = file.name;
          this.fileType = file.type;
          this.local_file_url = URL.createObjectURL(file);
          this.isLocalFile = true;
          this.showPreview = true;
          this.errorMessage = '';  // Clear error message
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Invalid File Type',
            text: 'Only PDF and Word documents are allowed.',
          });
          this.resetFileUpload();
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'No File Selected',
          text: 'Please select a file to upload.',
        });
        this.resetFileUpload();
      }
    },
    validateFile(file) {
      const allowedTypes = ['application/pdf', 'application/msword'];

      if(allowedTypes.includes(file.type)) {
        return true;
      } else {
        return false;
      }
    },

    getLocation() {
      if (navigator.geolocation) {
        Swal.fire({
          title: 'Fetching Location...',
          text: 'Please wait while we retrieve your location.',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            Swal.close();
            Swal.fire({
              title: 'Location Retrieved!',
              text: `Success`,
              icon: 'success',
              showConfirmButton: false,
              timer: 2000
            });
            this.locationError = '';

          },
        );
      } else {
        this.locationError = 'Geolocation is not supported by this browser.';
      }
    },

    fetch_type_of_organization() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/get_type_of_organization/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.type_of_organization = response.data.type_of_organization_data;
          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },
    fetch_type_of_profile() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_type_of_profile/`,
        type: 'GET',
        headers: {
          Authorization: `Token ${get_token()}`,
          'Content-Type': 'application/json',
        },
        success: (response) => {
          if (response.status === 'success') {
            this.type_of_profile = response.data.type_of_profile_data;

            this.show_questions()

          }
        },
        complete: () => {
          this.isLoading = false;
        },
      });
    },

    updateAnswer(questionId, value) {
      // Find the question object by its ID
      const question = this.profile_questions.find(q => q.question.id === questionId);

      // Update the answer for the question
      if (question) {
        question.answer = value; // Update with the selected value
      }
    },

    toggleCheckboxAnswer(questionId, option, isChecked) {
      const question = this.profile_questions.find(q => q.question.id === questionId);
      if (question) {
        // Initialize the answer as an empty array if it's undefined
        if (!Array.isArray(question.answer)) {
          question.answer = [];
        }
        // If the checkbox is checked, add the option to the answer
        if (isChecked) {
          question.answer.push(option);
        } else {
          // Otherwise, remove it from the answer
          const index = question.answer.indexOf(option);
          if (index !== -1) {
            question.answer.splice(index, 1);
          }
        }
      }
    },
    saveCompanyProfile() {

      Swal.fire({
          title: 'Submitting...',
          text: 'Please wait while we create the company profile.',
          allowOutsideClick: false,
          didOpen: () => {
              Swal.showLoading();
          }
      });

      this.isLoading = true;

      const businessProfile = this.type_of_profile.find(
        (profile) => profile.name.toUpperCase() === 'BUSINESS'
      );

      const formData = new FormData();
      formData.append('company_name', this.company_name);
      formData.append('type_of_organization_id', this.selected_type_of_organization);
      this.description = this.$refs.quillCompanyEditorRef.getHTML()
      formData.append('description', this.description);
      formData.append('email', this.email);
      formData.append('tell_number', this.tell_number);
      formData.append('location', this.location);
      formData.append('profile_type_id', businessProfile.id);
      const answeredQuestions = this.profile_questions
      .filter(question => question.answer !== undefined && question.answer !== null)
      .map(question => ({
        question_id: question.question.id,
        answer: question.answer
      }));
      formData.append('answers', JSON.stringify(answeredQuestions));

      $.ajax({
          url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/create_company_profile/`,
          type: 'POST',
          headers: {
              Authorization: `Token ${get_token()}`,
          },
          data: formData,
          processData: false,
          contentType: false,
          success: (response) => {
              if (response.status === 'success') {
                  Swal.fire({
                      title: 'Success',
                      text: 'Company Profile Created Successfully',
                      icon: 'success',
                      timer: 1000,
                      showConfirmButton: false,
                  }).then(() => {
                    $('#company_profile_modal').modal('hide');
                  });
              }
          },
          error: (error) => {
              console.error('Error:', error);
              Swal.fire({
                  title: 'Error',
                  text: 'An error occurred while creating the profile',
                  icon: 'error'
              });
          },
          complete: () => {
              this.isLoading = false;
          },
      });
  },
  fetchProfiles() {
    this.isLoading = true;

    $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_profiles/`,
        type: 'POST',
        headers: {
            Authorization: `Token ${get_token()}`,
            'Content-Type': 'application/json',
        },
        success: (response) => {
            if (response.status === 'success' && response.data.profiles) {
                this.base_profiles = response.data.profiles;
            }
        },
        complete: () => {
            this.isLoading = false;
        }
    });
},

clearPersonalData() {
    this.email = '';
    this.phone_number = '';
},

fetchCompanyProfile() {
  $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/get_company_profile/`,
      type: "POST",
      headers: {
          Authorization: `Token ${get_token()}`,
          "Content-Type": "application/json",
      },
      data: JSON.stringify(this.payload),
      success: (response) => {
          if (response.status === "success") {
              this.companyData = response.data;
              this.isBusinessProfile = true;
              this.team_members=this.companyData.team_members || [];
              this.pitchdecks=this.companyData.pitch_decks || [];
          }
      },
      error: (xhr, status, error) => {
          console.error("Error fetching company profile:", error);
          this.isBusinessProfile = false;
      }
  });
},

show_questions() {

  const businessProfile = this.type_of_profile.find(
    (profile) => profile.name.toLowerCase() === 'business'
  );
  const payload = {
    filter_values: {
      profile_type_id:  businessProfile.id,
    },
  };
  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/filter_assigned_profile_questions/`,
    type: "POST",
    headers: {
      Authorization: `Token ${get_token()}`,
      "Content-Type": "application/json",
    },
    data: JSON.stringify(payload),
    success: (response) => {
      this.profile_questions = response.data;
    },
  });
},

filterReports() {
  const payload = {
    filter_values: {
      base_profile_id: this.companyData?.base_profile?.id || this.base_profile_id,

    }
  }

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/filter_reports_api/`,
    method: 'POST',
    headers: {
        'Authorization': `Token ${this.getToken()}`,
        'Content-Type': 'application/json'
    },
    data: JSON.stringify(payload),
    success: (response) => {

      const status = response.status

      if(status === "success") {
        this.reports=  response.data.report_data;

        this.reports.forEach(report => {
          if (report && report.id) {
            

            this.getReportLikes(report);
          }});

        setTimeout(() => {
          this.loading = false;
      }, 1000);


      }

    },
    complete: () => {
        this.isLoading = false;
    },
  });
},
truncateDescription(description, maxLength = 25) {
  const words = description.split(/\s+/);
  if (words.length > maxLength) {
    return words.slice(0, maxLength).join(" ") + '...';
  }
  return description;
},

getDisplayedReportDescription(report) {
  const description = report.description;

  if (this.isReportExpanded(report.id)) {
    return description;
  }

  return this.truncateDescription(description);
},

toggleReportReadMore(reportId) {
  const index = this.expandedReports.indexOf(reportId);
  if (index === -1) {
    this.expandedReports.push(reportId);
  } else {
    this.expandedReports.splice(index, 1);
  }
},

isReportExpanded(reportId) {
  return this.expandedReports.includes(reportId);
},

shouldShowReadMore(report) {
  const description = report.description;
  const wordCount = description.split(/\s+/).length;

  return wordCount > 25;
},
hasSupportedFile(files) {
  if (Array.isArray(files)) {
    return files.some(fileObj => {
      const file = fileObj.file || {}; 
      const url = file.file_url || "";
      const supportedExtensions = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.xlsm', '.xlsb'];

    return supportedExtensions.some(ext => url.toLowerCase().indexOf(ext) !== -1);
    });
  }
  return false;
},
baseUrl(post, type) {
  const baseUrl = `${window.location.origin}${this.$route.path}`;

  // Dynamically build the URL based on the type (either 'hub' or 'report')
  if (type === 'exchange_hub') {
    return `${baseUrl}?hub_id=${post.id}`;
  } else if (type === 'report') {
    return `${baseUrl}?report_id=${post.id}`;
  }
  return baseUrl
},
copyReportLinkToClipboard(report) {
  const link = this.baseUrl(report, 'report');
  navigator.clipboard.writeText(link).then(() => {
    this.showToast('Link copied to clipboard!');
  })
},
showToast(message) {
  document.querySelector('#copyToast .toast-body').textContent = message;

  $('#copyToast').fadeIn(300).addClass('show');
  setTimeout(function() {
    $('#copyToast').fadeOut(300).removeClass('show');
  }, 3000);
},
display_comment_modal(data) {
  this.report_data = data;
  this.comment_modal_visible = true;
},
hide_comment_comment() {
  this.report_data = {};
  this.comment_modal_visible = false;
},

deleteReport(report_id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You won\'t be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: 'DELETE',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/delete_report_api/`,
            data: { report_id: report_id },
            headers: {
              'Authorization': `Token ${this.getToken()}`,
            },
            success: (response) => {
              const status = response.status;
              if (status === "success") {
                this.reports = this.reports.filter(report => report.id !== report_id);
                Swal.fire({
                  title: 'Deleted!',
                  text: 'The feed has been deleted.',
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 1000
                })
              }
            },
            error: () => {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to delete the feed. Please try again.',
              });
            }
          });
        }
      });
    },
    togglePinReport(report) {
      const newPinStatus = !report.is_pinned;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/pin_report_api/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          post_id: report.id,
          is_pinned: newPinStatus
        }),
        success: (response) => {
          if (response.status === 'success') {
            report.is_pinned = newPinStatus;

            const index = this.reports.indexOf(report);
            if (index > -1) {
              this.reports.splice(index, 1);
            }
            if (newPinStatus) {
              this.reports.unshift(report);
            } else {
              this.filterReports()
            }
          }
        },
      });
    },

    likeReport(report) {
      const reportId = report.id;
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_report_like/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: JSON.stringify({ report_id: reportId }),

        success: (response) => {
          const liked_report = this.reports.find(like => like.id === reportId);
          if (liked_report) {
            liked_report.like_count++;
          }
          if (response.status === "success") {
            const likeButton = document.getElementById(`like-button${reportId}`);
            const likedButton = document.getElementById(`liked-button${reportId}`);
            if (likeButton) {
              likeButton.classList.add('d-none');
            }

            if (likedButton) {
              likedButton.classList.remove('d-none');
            }
          }
        }
      });
    },
    getReportLikes(report) {
      if (!report || !report.id) {
        return;
      }

      $.ajax({
        type: "GET",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/retrieve_report_likes/`,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: { report_id: report.id },
        success: (response) => {
          if (response.status === "success") {
            const likes = response.data;
            report.like_count = likes.length;
            const userId = this.user_id;
            const isLiked = likes.some(like => like.user.id === parseInt(userId, 10));

            const likeButton = document.getElementById(`like-button${report.id}`);
            const likedButton = document.getElementById(`liked-button${report.id}`);

            if (likeButton) {
              likeButton.classList.toggle('d-none', isLiked);
            }

            if (likedButton) {
              likedButton.classList.toggle('d-none', !isLiked);
            }
          }
        },
      });
    },
    unlikeReport(report) {
      const reportId = report.id;
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_report_like/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: JSON.stringify({ report_id: reportId }),
        success: (response) => {
          if (response.status === "success") {
            const likeButton = document.getElementById(`like-button${reportId}`);
            const likedButton = document.getElementById(`liked-button${reportId}`);

            const unliked_report = this.reports.find(like => like.id === report.id);
            if (unliked_report) {
              unliked_report.like_count--;
            }

            if (likeButton) {
              likeButton.classList.remove('d-none');
            }

            if (likedButton) {
              likedButton.classList.add('d-none');
            }
          }
        }
      });
    },

    edit_report(report){
                  this.report_name=report.name
                  const raw=report.description
                  this.report_description = raw.replace(/<p>|<\/p>|<br>/g, "").trim();
                  
                  this.report_id=report.id
                  this.edit_documents=report
                  this.$nextTick(() => {
                    if (this.$refs.quillReportRef) {
                      const quillEditor = this.$refs.quillReportRef.getQuill();
                      if (quillEditor) {
                        quillEditor.setContents([
                          { insert: this.report_description || "" },
                        ]);
                      }
                    }
                  });
                },
    
        edit_report_data() {
          Swal.fire({
            title: 'Submitting...',
            text: 'Please wait while we process your request.',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
          this.isSubmitting = true;
          const formData = new FormData();
          const plainText = this.$refs.quillReportRef.getText().trim();
          this.report_description = plainText;
          formData.append('description', this.report_description);
          formData.append('report_id', this.report_id);
          if (this.upload_media) {
            formData.append('file', this.upload_media);
          }
          if (this.audio_file) {
            formData.append('file', this.audio_file, this.audio_file_name);
          }
          if (this.selected_topic) {
            formData.append('topic_id', this.selected_topic);
          }
    
          $.ajax({
            type: 'POST',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/update_report_api/`,
            data: formData,
            processData: false,
            contentType: false,
            headers: {
              'Authorization': `Token ${this.getToken()}`,
            },
            success: (response) => {
              if (response.status === 'success') {
                const updatedReport = response.updated_data;
                const reportIndex = this.reports.findIndex(
                  (hub) => hub.id === updatedReport.id
                );
    
                if (reportIndex !== -1) {
                  this.reports.splice(reportIndex, 1, updatedReport);
                }
                Swal.fire({
                  icon: 'success',
                  title: response.message,
                  showConfirmButton: false,
                  timer: 1000
                }).then(() => {
                  $('#edit_report_modal').modal('hide');
                  this.resetSelection();
                });
              }
            },
            error: (response) => {
              Swal.close()
              const response_data = response.responseJSON;
              this.errors.edit_name = response_data.message
            },
            complete: () => {
              this.isSubmitting = false;
            }
          });
        },
        resetSelection(){
          this.report_name = '';
          this.report_description = '';
          this.report_id = null;
          this.edit_documents = {};

          this.upload_media='';
          this.audio_file = null;
          this.errors={}
        },

        add_member() {

          const formData = new FormData();
          formData.append('first_name', this.first_name);
          formData.append('last_name', this.last_name);
          formData.append('email', this.email);
          formData.append('role', this.member_role);
          formData.append('company_id', this.companyData.id);
        
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/add_team_member_api/`,
            method: "POST",
            headers: {
              Authorization: `Token ${this.getToken()}`
            },
            data: formData,
            processData: false,
            contentType: false,
            success: (response) => {
              if (response.status === "success") {
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  text: "Team member added successfully.",
                  showConfirmButton: false,
                  timer: 2000
                });
                this.team_members.push(response.data);

                $('#add_team_modal').modal('hide');
              } 
            },
            error: (xhr) => {
              const response = xhr.responseJSON;
              this.errors.email= response.message;

            },
            complete: () => {
              this.resetForm();
            }
          });
        },
        resetForm() {
          this.first_name = '';
          this.last_name = '';
          this.email = '';
          this.member_role = '';
          this.edit_member_id=null;
          this.errors = {};
        },

        handle_pitch_file_upload(event) {
          const file = event.target.files[0];
    
          if (file) {
            if (file.type.startsWith("audio/")) {
              this.fileError = "Audio files are not allowed.";
              this.upload_media = null;
              this.fileName = "";
              event.target.value = ""; // Clear file input
            } else {
              this.fileName = file.name;
              this.fileError = "";
              this.upload_media = file;
            }
          } else {
            this.fileName = "";
            this.fileError = "";
            this.upload_media = null;
          }
        },
        create_pitchdeck() {

          Swal.fire({
            title: 'Submitting...',
            text: 'Please wait while we upload your pitch deck.',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        
          const formData = new FormData();
          this.pitch_description=this.$refs.quillPitchdeckEditorRef.getHTML()
          formData.append('company_id',this.companyData.id);
          formData.append('summary', this.pitch_description||'');
          formData.append('file', this.upload_media);
        
          $.ajax({
            type: 'POST',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/create_pitch_deck_api/`,
            data: formData,
            processData: false,
            contentType: false,
            headers: {
              Authorization: `Token ${this.getToken()}`,
            },
            success: (response) => {
              if (response.status === 'success') {
                Swal.fire({
                  icon: 'success',
                  title: 'Pitch Deck Uploaded',
                  text: 'Your pitch deck has been successfully uploaded.',
                  showConfirmButton: false,
                  timer: 2000,
                });
        
                this.pitchdecks.unshift(response.data); // Add the new pitch deck to the list
                $('#pitchdeck_modal').modal('hide');
                this.resetPitchdeckForm();
              }
            },
            error: (response) => {
              Swal.close();
              const response_data = response.responseJSON;
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: response_data.message || 'An error occurred while uploading the pitch deck.',
              });
            },
            complete: () => {
              Swal.close();
            },
          });
        },


        resetPitchdeckForm() {
          this.pitchdeckTitle = '';
          this.pitch_description = '';
          this.upload_media = null;
          this.fileName = '';
          this.fileError = '';
          this.edit_pitchdeck_id = null;
        },

        delete_team_member(member_id){

          const formData = new FormData();
          formData.append('member_id',member_id);
          formData.append('company_id', this.companyData.id)

          Swal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) {
          $.ajax({
            type: 'DELETE',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/delete_team_member_api/`,
            data: formData,
            processData: false,
            contentType: false,
            headers: {
              Authorization: `Token ${this.getToken()}`,
            },
            success: (response) => {
              if (response.status === 'success') {
                Swal.fire({
                  icon: 'success',
                  title: 'Member deleted',
                  text:response.message,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
              this.team_members = this.team_members.filter(member => member.id !== member_id);
            },
            error: (response) => {
              Swal.close();
              const response_data = response.responseJSON;
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: response_data.message 
              });
            },
          });
        }
      });

    },

        delete_pitch_deck(pitch_deck_id){

          const formData = new FormData();
          formData.append('pitch_deck_id',pitch_deck_id);
          formData.append('company_id', this.companyData.id)


          Swal.fire({
            title: 'Are you sure?',
            text: 'You won\'t be able to revert this!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.isConfirmed) {
          $.ajax({
            type: 'DELETE',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/delete_pitch_deck_api/`,
            data: formData,
            processData: false,
            contentType: false,
            headers: {
              Authorization: `Token ${this.getToken()}`,
            },
            success: (response) => {
              if (response.status === 'success') {
                Swal.fire({
                  icon: 'success',
                  title: 'Pitch deck deleted',
                  text:response.message,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
              this.pitchdecks = this.pitchdecks.filter(pitch => pitch.id !== pitch_deck_id);
            },
            error: (response) => {
              Swal.close();
              const response_data = response.responseJSON;
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: response_data.message 
              });
            },
          });
            }
          });
        },

        open_edit_member_modal(member) {
          this.edit_member_id = member.id;
          this.first_name = member.first_name;
          this.last_name = member.last_name;
          this.email = member.email;
          this.member_role = member.role;
          this.errors = {};
          $('#add_team_modal').modal('show');
        },

        open_edit_pitchdeck_modal(pitchdeck) {
          this.edit_pitchdeck_id = pitchdeck.id;
          this.pitch_description = pitchdeck.summary || '';
          // Safely get the file name from the first file in the array, if it exists
          if (
            Array.isArray(pitchdeck.picth_deck_files) &&
            pitchdeck.picth_deck_files.length > 0 &&
            pitchdeck.picth_deck_files[0].file &&
            pitchdeck.picth_deck_files[0].file.name
          ) {
            this.fileName = pitchdeck.picth_deck_files[0].file.name;
          } else {
            this.fileName = '';
          }
          this.fileError = '';
          this.upload_media = null;
          $('#pitchdeck_modal').modal('show');
          this.$nextTick(() => {
            // Ensure the Quill editor is updated with the summary HTML
            if (this.$refs.quillPitchdeckEditorRef && this.pitch_description) {
              // For QuillEditor, set HTML content directly
              this.$refs.quillPitchdeckEditorRef.setHTML(this.pitch_description);
            }
          });
        },
      
        update_member() {
          if (!this.edit_member_id) return; // Prevent update if not editing
          const formData = new FormData();
          formData.append('member_id', this.edit_member_id);
          formData.append('first_name', this.first_name);
          formData.append('last_name', this.last_name);
          formData.append('email', this.email);
          formData.append('role', this.member_role);
          formData.append('company_id', this.companyData.id);
      
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/update_team_member_api/`,
            method: "POST",
            headers: {
              Authorization: `Token ${this.getToken()}`
            },
            data: formData,
            processData: false,
            contentType: false,
            success: (response) => {
              if (response.status === "success") {
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  text: "Team member updated successfully.",
                  showConfirmButton: false,
                  timer: 2000
                });
                const updatedMember = response.data;
                const memberIndex = this.team_members.findIndex(
                  (member) => member.id === updatedMember.id
                );
                if (memberIndex !== -1) {
                  this.team_members.splice(memberIndex, 1, updatedMember);
                }

                $('#add_team_modal').modal('hide');
              }
            },
            error: (xhr) => {
              const response = xhr.responseJSON;
              this.errors.email = response?.message || "Update failed";
            },
            complete: () => {
              this.resetForm();
              this.edit_member_id = null;
            }
          });
        },

        update_pitchdeck() {
          Swal.fire({
            title: 'Updating...',
            text: 'Please wait while we update your pitch deck.',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
      
          const formData = new FormData();
          this.pitch_description = this.$refs.quillPitchdeckEditorRef.getHTML();
          formData.append('pitch_deck_id', this.edit_pitchdeck_id);
          formData.append('company_id', this.companyData.id);
          formData.append('summary', this.pitch_description || '');
          if (this.upload_media) {
            formData.append('file', this.upload_media);
          }
      
          $.ajax({
            type: 'POST',
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/update_pitch_deck_api/`,
            data: formData,
            processData: false,
            contentType: false,
            headers: {
              Authorization: `Token ${this.getToken()}`,
            },
            success: (response) => {
              if (response.status === 'success') {
                Swal.fire({
                  icon: 'success',
                  title: 'Pitch Deck Updated',
                  text: 'Your pitch deck has been successfully updated.',
                  showConfirmButton: false,
                  timer: 2000,
                });
                // Update the pitchdeck in the array
                const updatedPitchdeck = response.data;
                const pitchIndex = this.pitchdecks.findIndex(
                  (pitch) => pitch.id === updatedPitchdeck.id
                );
                if (pitchIndex !== -1) {
                  this.pitchdecks.splice(pitchIndex, 1, updatedPitchdeck);
                }
                $('#pitchdeck_modal').modal('hide');
                this.resetPitchdeckForm();
              }
            },
            error: (response) => {
              Swal.close();
              const response_data = response.responseJSON;
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: response_data.message || 'An error occurred while updating the pitch deck.',
              });
            },
            complete: () => {
              this.edit_pitchdeck_id = null;
            },
          });
        },

        submitFinanceAnswers() {
          Swal.fire({
            title: 'Submitting...',
            text: 'Please wait while we submit your finance answers.',
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            }
          });
        
          this.isLoading = true;
        
          // Collect only finance answers from all finance forms/sections/questions
          const financeAnswers = this.profile_questions
            ?.filter(q => q.tab_field === 'finance')
            ?.flatMap(pf => pf?.form?.form_sections || [])
            ?.flatMap(fs => fs?.section?.question_sections || [])
            ?.filter(qs => qs?.answer !== undefined && qs?.answer !== null)
            ?.map(qs => ({
              question_id: qs?.question?.id,
              answer: Array.isArray(qs.answer) ? qs.answer.join(', ') : qs.answer
            }));
        
          const payload = {
            base_profile_id: this.companyData?.base_profile?.id,
            answers: financeAnswers
          };
        
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/system_management/answer_questions_for_base_profile/`,
            type: 'POST',
            headers: {
              Authorization: `Token ${get_token()}`,
              "Content-Type": "application/json"
            },
            data: JSON.stringify(payload),
            success: (response) => {
              if (response.status === 'success') {
                Swal.fire({
                  title: 'Success',
                  text: 'Finance answers submitted successfully',
                  icon: 'success',
                  timer: 1000,
                  showConfirmButton: false,
                }).then(() => {
                  $('#company_finance_modal').modal('hide');
                  this.fetchCompanyProfile();
                });
              }
            },
            error: (error) => {
              console.error('Error:', error);
              Swal.fire({
                title: 'Error',
                text: 'An error occurred while submitting finance answers',
                icon: 'error'
              });
            },
            complete: () => {
              this.isLoading = false;
            },
          });
        },
        addReportToHome(newReport) {
          if (newReport) {

            newReport.total_comments = newReport.total_comments || 0;
            newReport.like_count = newReport.like_count || 0;
            if(newReport.portal.is_public===true){
              this.reports.unshift(newReport);
            }
          }
          this.temporaryPost = null;
        },

  on_dynamic_tab_click(section) {

  const sectionId = section.sectionId || section.section?.id;
  this.activeTab = 'section_' + sectionId;
  this.check_section_access_from_tab_requests(sectionId, section);

},
check_section_access_from_tab_requests(sectionId, section) {
  const creatorId = String(this.companyData?.base_profile?.creater?.id || this.companyData?.base_profile?.creater);
  const currentUserId = String(this.user_details.user_id);

  if (creatorId === currentUserId) {
    section.access_approved = true;
    section.access_requested = false;
    section.access_checked = true;
    return;
  }

  const active_profile = this.active_profile;
  const active_profile_id = active_profile ? (active_profile.id || active_profile) : null;
  const requests = this.companyData.tab_access_requests || [];

  // Find request for this section and this user
  const section_request = requests.find(req =>
    String(req.section) === String(sectionId) &&
    (String(req.requester) === String(active_profile_id) || String(req.requester?.id) === String(active_profile_id))
  );

  if (!section_request) {
    section.access_approved = false;
    section.access_requested = false;
  } else {
    const status = section_request.status?.toLowerCase();
    if (status === 'approved') {

      section.access_approved = true;
      section.access_requested = false;
    } else if (status === 'pending') {
      section.access_approved = false;
      section.access_requested = true;
    } else {

      section.access_approved = false;
      section.access_requested = false;
    }
  }
  section.access_checked = true;
},
  request_tab_access(section) {
  const requestPayload = {
    target_profile_id: this.companyData.id,
    tab_key: 'section', // Use a generic key or your business logic
    section_id: section?.sectionId || section?.section?.id,
  };

  $.ajax({
    url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/request_tab_access_api/`,
    method: 'POST',
    data: JSON.stringify(requestPayload),
    headers: {
      Authorization: `Token ${get_token()}`,
      "Content-Type": "application/json"
    },
    success: () => {
      section.access_requested = true;
      Swal.fire({
        icon: 'success',
        title: 'Request Sent',
        text: 'Your access request has been sent. Please wait for approval.',
        timer: 2000,
        showConfirmButton: false
      });
    },
    error: (err) => {
      console.error("Access request error:", err);
    },
  });
},

      approve_request(req) {
      Swal.fire({
        title: 'Approve Request?',
        text: `Approve access for ${req.requester?.profile_name || req.requester?.first_name || req.requester}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Approve',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/approve_tab_access_request_api/`,
            method: 'POST',
            data: JSON.stringify({ request_id: req.id }),
            headers: {
              Authorization: `Token ${get_token()}`,
              "Content-Type": "application/json"
            },
            success: () => {
              Swal.fire({
                icon: 'success',
                title: 'Approved',
                text: 'Access request approved.',
                timer: 1500,
                showConfirmButton: false
              });
              req.status = 'approved';

            },
            error: () => {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to approve request.'
              });
            }
          });
        }
      });
    },

    decline_request(req) {
      Swal.fire({
        title: 'Decline Request?',
        text: `Decline access for ${req.requester?.profile_name || req.requester?.first_name || req.requester}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Decline',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            url: `${process.env.VUE_APP_BACKEND_API_URL}/company_management/decline_tab_access_request_api/`,
            method: 'POST',
            data: JSON.stringify({ request_id: req.requester.id,section_id:req.section ,company_name: this.companyData?.company_name ,section_name: req.section_name }),
            headers: {
              Authorization: `Token ${get_token()}`,
              "Content-Type": "application/json"
            },
            success: () => {
              Swal.fire({
                icon: 'success',
                title: 'Declined',
                text: 'Access request declined.',
                timer: 1500,
                showConfirmButton: false
              });
              // Update the request status locally
              req.status = 'declined';

            },
            error: () => {
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to decline request.'
              });
            }
          });
        }
      });
    },
      },
    };